//全局注册组件
//修改密码
import changePassword from '@/components/changePassword.vue';


//数组存放接收的组件名
const components = [
  { name: "changePassword", con: changePassword },
]
//循环注册组件
const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component.con);
  });
};

export default {
  install
};
